import { CounterBox, CounterLegend, CounterValue } from './styled-components'

interface BreakCounterProps {
  label: string
  currentCount: number
  max: number
}

const BreakCounter = ({ label, currentCount, max }: BreakCounterProps) => (
  <CounterBox>
    <CounterLegend>{label}</CounterLegend>
    <CounterValue id='break-counter'>{`${currentCount} / ${max}`}</CounterValue>
  </CounterBox>
)

export default BreakCounter
